import React, { useCallback, useEffect, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import { DateTimeIcon } from '../Icons/Icons';
import styles from './DateTimePicker.module.css'
import { formatDDMMYY, formatDateToHour, formatDateToTime } from '../../utils';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';

const cx = classNames.bind(styles)
const DateTimePicker = ({
    title,
    disabled,
    value,
    size = "normal",
    onChange,
    styles,
    className,
    typeDate = "datetime-local",
    disabledDate,
    disabledDateTime,
    showTime,
    format,
    placeholder,
    maxDate,
    minDate
}) => {
    const handleChangeDay = (value, dateString) => {
       
        
       if(value){
        onChange({
            target: {
                value: dayjs(value).toISOString(),
            }
        })
       }
       else{
        onChange({
            target: {
                value: null,
            }
        })
       }
    }

    return (
        <div style={{ ...styles }} className={cx("form-control")} >
            <p className={cx("title")}>{title}</p>
            <div className={cx('input-content')} >
                <DatePicker
                    format={format}
                    disabledDate={disabledDate}
                    disabledTime={disabledDateTime}
                    showTime={showTime}
                    suffixIcon={<DateTimeIcon />}
                    placeholder={placeholder}
                    className={cx('date-picker')}
                    onCalendarChange={handleChangeDay}
                    value={value ? dayjs(new Date(value)) : ''}
                    maxDate={maxDate}
                    minDate={minDate}
                />
            </div>
        </div>
    );
};

export default DateTimePicker;